import type { Agenda, AgendaItem, AgendaModule } from "@repo/types";

export const agendaTemplateService = {
  getCopiedAgendaItem: (
    agendaItem: AgendaItem,
    teamId: string
  ): Partial<AgendaItem> => {
    const copiedAgendaItem: Partial<AgendaItem> = {
      ...agendaItem,
      id: undefined,
      teamId: teamId,
      parentIds: [],
      documents: undefined,
      status: "draft",

      createdAt: undefined,
      createdBy: undefined,
      updatedAt: undefined,
      updatedBy: undefined,
    };

    // also switch the approving team if set (otherwise the item's team reverts)
    if (
      copiedAgendaItem.approver &&
      copiedAgendaItem.approver.approverType === "team"
    ) {
      copiedAgendaItem.approver.approverId = teamId;
    }

    return copiedAgendaItem;
  },

  getCopiedAgendaModule: (
    agendaModule: AgendaModule,
    teamId: string,
    agendaItemIds?: string[]
  ): Partial<AgendaModule> => {
    const copiedAgendaModule: Partial<AgendaModule> = {
      ...agendaModule,
      id: undefined, // don't overwrite old item
      teamId: teamId,
      parentIds: [],
      agendaItemIds: agendaItemIds ?? [],
      agendaItems: undefined,
      status: "draft",

      createdAt: undefined,
      createdBy: undefined,
      updatedAt: undefined,
      updatedBy: undefined,
    };
    return copiedAgendaModule;
  },

  getCopiedAgenda: (
    agenda: Agenda,
    teamId: string,
    agendaModuleIds?: string[]
  ): Partial<Agenda> => {
    const copiedAgenda: Partial<Agenda> = {
      ...agenda,
      id: undefined, // don't overwrite old item
      teamId: teamId,
      agendaModuleIds: agendaModuleIds ?? [],
      parentIds: [],
      agendaModules: [],
      status: "draft",

      createdAt: undefined,
      createdBy: undefined,
      updatedAt: undefined,
      updatedBy: undefined,
    };

    return copiedAgenda;
  },
};
